import { render, staticRenderFns } from "./CityDetail.vue?vue&type=template&id=1ae0fa2a&scoped=true"
import script from "./CityDetail.vue?vue&type=script&lang=js"
export * from "./CityDetail.vue?vue&type=script&lang=js"
import style0 from "./CityDetail.vue?vue&type=style&index=0&id=1ae0fa2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae0fa2a",
  null
  
)

export default component.exports